import { useState } from 'react'
import { AppShell } from '../components/AppShell'
import { useAuth } from '../lib/auth'
import { SettingsSidebar } from './SettingsPage'

export function SettingsCommunicationPage() {
  const { user } = useAuth()
  const [primaryEmail] = useState(user?.email ?? '')
  const [phone, setPhone] = useState('')
  const [marketing, setMarketing] = useState(false)
  const [productUpdates, setProductUpdates] = useState(true)
  const [saved, setSaved] = useState(false)

  return (
    <AppShell page="settings" breadcrumb={<span className="topbar__breadcrumb-current">Settings · Communication</span>}>
      <header className="page-header">
        <div className="page-header__main">
          <p className="page-header__eyebrow"><span>Account</span></p>
          <h1 className="page-header__title">Communication</h1>
          <p className="page-header__subtitle">How we reach you for transactional and marketing messages.</p>
        </div>
      </header>

      <div className="settings-layout">
        <SettingsSidebar active="notifications" />

        <div className="settings-content">
          <section className="settings-card">
            <header className="settings-card__header">
              <div className="settings-card__title-group">
                <h2 className="settings-card__title">Contact details</h2>
                <p className="settings-card__description">
                  Transactional emails (verification, payouts, account changes) always go to your primary email.
                </p>
              </div>
            </header>
            <div className="settings-card__body">
              <form className="form" onSubmit={(e) => { e.preventDefault(); setSaved(true) }}>
                <div className="form-row">
                  <div className="field field--success">
                    <label className="field__label" htmlFor="comm-email">Primary email</label>
                    <input id="comm-email" className="field__input" type="email" value={primaryEmail} disabled />
                    <span className="field__helper">Contact support to change.</span>
                  </div>
                  <div className="field">
                    <label className="field__label" htmlFor="comm-phone">Phone (optional)</label>
                    <input id="comm-phone" className="field__input" type="tel" placeholder="+36 30 123 4567"
                      value={phone} onChange={(e) => { setPhone(e.target.value); setSaved(false) }} />
                  </div>
                </div>

                <div className="form-section">
                  <label className="toggle-row">
                    <input type="checkbox" checked={productUpdates}
                      onChange={(e) => { setProductUpdates(e.target.checked); setSaved(false) }} />
                    <span>
                      <strong style={{ display: 'block' }}>Product updates</strong>
                      <span style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>
                        New features, tier changes, important platform announcements.
                      </span>
                    </span>
                  </label>
                  <label className="toggle-row" style={{ marginTop: 'var(--space-3)' }}>
                    <input type="checkbox" checked={marketing}
                      onChange={(e) => { setMarketing(e.target.checked); setSaved(false) }} />
                    <span>
                      <strong style={{ display: 'block' }}>Marketing emails</strong>
                      <span style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>
                        Occasional offers and tier promotions. Off by default.
                      </span>
                    </span>
                  </label>
                </div>

                <div className="save-bar" style={{ marginTop: 'var(--space-4)' }}>
                  <div className="save-bar__status">
                    {saved && <span style={{ color: 'var(--color-success-text)' }}>Saved (local-only — backend wiring pending).</span>}
                  </div>
                  <div className="save-bar__actions">
                    <button type="submit" className="btn btn--primary">Save preferences</button>
                  </div>
                </div>
              </form>
            </div>
          </section>
        </div>
      </div>
    </AppShell>
  )
}
